var exports = {
  "kL": "ChannelPermissionsTab.module__container___WUpNN0",
  "Ut": "ChannelPermissionsTab.module__syncBanner___WUpNN0",
  "iH": "ChannelPermissionsTab.module__syncBannerSynced___WUpNN0",
  "bT": "ChannelPermissionsTab.module__syncBannerUnsynced___WUpNN0",
  "Vg": "ChannelPermissionsTab.module__grid___WUpNN0",
  "s4": "ChannelPermissionsTab.module__leftTitle___WUpNN0",
  "pG": "ChannelPermissionsTab.module__right___WUpNN0",
  "ze": "ChannelPermissionsTab.module__rightScroller___WUpNN0",
  "CI": "ChannelPermissionsTab.module__sectionRow___WUpNN0",
  "bV": "ChannelPermissionsTab.module__sectionHeader___WUpNN0",
  "Gf": "ChannelPermissionsTab.module__sectionTitle___WUpNN0",
  "bQ": "ChannelPermissionsTab.module__subtleText___WUpNN0",
  "cy": "ChannelPermissionsTab.module__permHeaderRow___WUpNN0",
  "mA": "ChannelPermissionsTab.module__permHelp___WUpNN0",
  "p$": "ChannelPermissionsTab.module__emptyState___WUpNN0",
  "rV": "ChannelPermissionsTab.module__overwriteItem___WUpNN0",
  "w7": "ChannelPermissionsTab.module__overwriteItemSelected___WUpNN0",
  "Vd": "ChannelPermissionsTab.module__overwriteItemContextMenuOpen___WUpNN0",
  "FD": "ChannelPermissionsTab.module__overwriteIcon___WUpNN0",
  "m4": "ChannelPermissionsTab.module__roleDot___WUpNN0",
  "l": "ChannelPermissionsTab.module__overwriteName___WUpNN0",
  "Fs": "ChannelPermissionsTab.module__permSearchRow___WUpNN0",
  "XZ": "ChannelPermissionsTab.module__permSearchInput___WUpNN0",
  "sN": "ChannelPermissionsTab.module__layoutButtons___WUpNN0",
  "Zh": "ChannelPermissionsTab.module__layoutButton___WUpNN0",
  "HU": "ChannelPermissionsTab.module__permCategories___WUpNN0",
  "Fv": "ChannelPermissionsTab.module__mobileOverrideList___WUpNN0",
  "E_": "ChannelPermissionsTab.module__mobileListHeader___WUpNN0",
  "JJ": "ChannelPermissionsTab.module__mobileListTitle___WUpNN0",
  "_4": "ChannelPermissionsTab.module__mobileOverrides___WUpNN0",
  "Ud": "ChannelPermissionsTab.module__mobileOverrideItem___WUpNN0",
  "wP": "ChannelPermissionsTab.module__mobileOverrideName___WUpNN0",
  "wu": "ChannelPermissionsTab.module__mobileOverrideChevron___WUpNN0",
  "yg": "ChannelPermissionsTab.module__mobileBackRow___WUpNN0",
};

module.exports = exports;
